import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'num_of_commuting_injuries_incl_fatalities_in_the_last_12_months'

export const dataPointDefinition = {
  retracedId: 'num_of_commuting_injuries_incl_fatalities_in_the_last_12_months',
  name: 'Number of commuting injuries (incl. fatalities) in the last 12 months:',
  description:
    'Include both minor and serious injuries and fatalities that occurred during travel to and from work.\r\r\n\r\r\nInjuries and fatalities at work/ in the workplace are covered separately. ',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-fir-20',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17070,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
